// import React, { useEffect, useState } from "react";
// import styles from "./JobInfoTables.module.css";

// const JobInfoTables = ({ jobId }) => {
//   const [job, setJob] = useState(null);

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs/${jobId}`)
//       .then((res) => res.json())
//       .then((data) => setJob(data))
//       .catch((err) => console.error("Failed to fetch job info:", err));
//   }, [jobId]);

//   if (!job) return <p>Loading...</p>;

//   return (
//     <div className={styles.gridContainer}>
//       {/* Important Dates */}
//       <div className={styles.box}>
//         <div className={styles.title}>IMPORTANT DATES</div>
//         <hr className={styles.divider} />
//         <div className={styles.body}>
//           {job.dates?.map((item, i) => (
//             <div key={i}>
//               <strong
//                 className={
//                   item.label.toLowerCase().includes("last date")
//                     ? styles.redText
//                     : item.label.toLowerCase().includes("exam")
//                     ? styles.blueText
//                     : ""
//                 }
//               >
//                 {item.label} :
//               </strong>{" "}
//               {item.value}
//             </div>
//           ))}
//         </div>
//       </div>



      

//       {/* Application Fee */}
//       <div className={styles.box}>
//         <div className={styles.title}>APPLICATION FEE</div>
//         <hr className={styles.divider} />
//         <div className={styles.body}>
//           {job.fees?.map((fee, i) => (
//             <div key={i}>
//               {fee.label} : <strong>Rs.{fee.amount}/-</strong>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Total Posts */}
//       <div className={styles.box}>
//         <div className={styles.title}>TOTAL POSTS</div>
//         <hr className={styles.divider} />
//         <div className={styles.body}>
//           <div>
//             <strong>Total Posts:</strong> {job.posts?.TotalPost || "N/A"}
//           </div>
//           {job.posts?.category?.map((cat, i) => (
//             <div key={i}>
//               {cat.label} : <strong>{cat.value}</strong>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Age Limit */}
//       <div className={styles.box}>
//         <div className={styles.title}>AGE LIMIT</div>
//         <hr className={styles.divider} />
//         <div className={styles.body}>
//           <div>
//             <strong>As On:</strong> {job.age?.asOn || "N/A"}
//           </div>
//           {job.age?.limits?.map((limit, i) => (
//             <div key={i}>{limit}</div>
//           ))}
//           {job.age?.note && <div>{job.age.note}</div>}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default JobInfoTables;







// import React, { useEffect, useState } from "react";
// import styles from "./JobInfoTables.module.css";

// const JobInfoTables = ({ jobId }) => {
//   const [job, setJob] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs/${jobId}`)
//       .then((res) => res.json())
//       .then((data) => {
//         setJob(data);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Failed to fetch job info:", err);
//         setLoading(false);
//       });
//   }, [jobId]);

//   if (loading) {
//     return (
//       <div className={styles.loaderWrapper}>
//         <div className={styles.loader}></div>
//       </div>
//     );
//   }

//   return (
//     <div className={styles.gridContainer}>
//       {/* Important Dates */}
//       <div className={styles.box} style={{ borderTopColor: "#ff4d4f" }}>
//         <div className={styles.title}>IMPORTANT DATES</div>
//         <hr className={styles.divider} />
//         <ul className={styles.body}>
//           {job.dates?.map((item, i) => (
//             <li key={i}>
//               <strong
//                 className={
//                   item.label.toLowerCase().includes("last date")
//                     ? styles.redText
//                     : item.label.toLowerCase().includes("exam")
//                     ? styles.blueText
//                     : ""
//                 }
//               >
//                 {item.label}:
//               </strong>{" "}
//               {item.value}
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Application Fee */}
//       <div className={styles.box} style={{ borderTopColor: "#00c8ff" }}>
//         <div className={styles.title}>APPLICATION FEE</div>
//         <hr className={styles.divider} />
//         <ul className={styles.body}>
//           {job.fees?.map((fee, i) => (
//             <li key={i}>
//               {fee.label} : <strong>Rs.{fee.amount}/-</strong>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Total Posts */}
//       <div className={styles.box} style={{ borderTopColor: "#52c41a" }}>
//         <div className={styles.title}>TOTAL POSTS</div>
//         <hr className={styles.divider} />
//         <ul className={styles.body}>
//           <li>
//             <strong>Total Posts:</strong> {job.posts?.TotalPost || "N/A"}
//           </li>
//           {job.posts?.category?.map((cat, i) => (
//             <li key={i}>
//               {cat.label} : <strong>{cat.value}</strong>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Age Limit */}
//       <div className={styles.box} style={{ borderTopColor: "#a64dff" }}>
//         <div className={styles.title}>AGE LIMIT</div>
//         <hr className={styles.divider} />
//         <ul className={styles.body}>
//           <li>
//             <strong>As On:</strong> {job.age?.asOn || "N/A"}
//           </li>
//           {job.age?.limits?.map((limit, i) => (
//             <li key={i}>{limit}</li>
//           ))}
//           {job.age?.note && <li>{job.age.note}</li>}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default JobInfoTables;






import React from "react";
import styles from "./JobInfoTables.module.css";

const JobInfoTables = ({ job }) => {
  if (!job) return null; // fallback safeguard

  return (
    <div className={styles.gridContainer}>
      {/* Important Dates */}
      {/* <div className={styles.box} style={{ borderTopColor: "#ff4d4f" }}>
        <div className={styles.title}>IMPORTANT DATES</div>
        <hr className={styles.divider} />
        <ul className={styles.body}>
          {job.dates?.map((item, i) => (
            <li key={i}>
              <strong
                className={
                  item.label.toLowerCase().includes("last date")
                    ? styles.redText
                    : item.label.toLowerCase().includes("exam")
                    ? styles.blueText
                    : ""
                }
              >
                {item.label}:
              </strong>{" "}
              {item.value}
            </li>
          ))}
        </ul>
      </div> */}

{/* 
    <div className={styles.box} style={{ borderTopColor: "#ff4d4f" }}>
        <div className={styles.title}>IMPORTANT DATES</div>
        <hr className={styles.divider} />
        <ul className={styles.body}>
          {job.dates?.map((item, i) => {
            let formattedDate = item.value;
            try {
              if (item.value) {
                const dateObj = new Date(item.value);
                formattedDate = dateObj.toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                });
              }
            } catch (e) {
              console.error("Invalid date format:", item.value);
            }

            return (
              <li key={i}>
                <strong
                  className={
                    item.label.toLowerCase().includes("last date")
                      ? styles.redText
                      : item.label.toLowerCase().includes("exam")
                      ? styles.blueText
                      : ""
                  }
                >
                  {item.label}:
                </strong>{" "}
                {formattedDate}
              </li>
            );
          })}
        </ul>
      </div> */}


      <div className={styles.box} style={{ borderTopColor: "#ff4d4f" }}>
            <div className={styles.title}>IMPORTANT DATES</div>
            <hr className={styles.divider} />
            <ul className={styles.body}>
              {job.dates?.map((item, i) => {
                let formattedDate = item.value;
                try {
                  if (item.value) {
                    const dateObj = new Date(item.value);
                    formattedDate = dateObj.toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    });
                  }
                } catch (e) {
                  console.error("Invalid date format:", item.value);
                }

                return (
                  <li key={i}>
                    <span
                      className={
                        item.label.toLowerCase().includes("last date")
                          ? styles.redText
                          : item.label.toLowerCase().includes("exam")
                          ? styles.blueText
                          : ""
                      }
                    >
                      {item.label}:
                    </span>{" "}
                    <span style={{ fontWeight: "bold", color: "#000" }}>
                      {formattedDate}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>


      



      {/* Application Fee */}
      <div className={styles.box} style={{ borderTopColor: "#00c8ff" }}>
        <div className={styles.title}>APPLICATION FEE</div>
        <hr className={styles.divider} />
        <ul className={styles.body}>
          {job.fees?.map((fee, i) => (
            <li key={i}>
              {fee.label} : <strong>Rs.{fee.amount}/-</strong>
            </li>
          ))}
        </ul>
      </div>

      {/* Total Posts */}
      <div className={styles.box} style={{ borderTopColor: "#52c41a" }}>
        <div className={styles.title}>TOTAL POSTS</div>
        <hr className={styles.divider} />
        <ul className={styles.body}>
          <li>
            <strong>Total Posts:</strong> {job.posts?.TotalPost || "N/A"}
          </li>
          {job.posts?.category?.map((cat, i) => (
            <li key={i}>
              {cat.label} : <strong>{cat.value}</strong>
            </li>
          ))}
        </ul>
      </div>

      {/* Age Limit */}
      <div className={styles.box} style={{ borderTopColor: "#a64dff" }}>
        <div className={styles.title}>AGE LIMIT</div>
        <hr className={styles.divider} />
        <ul className={styles.body}>
          <li>
            <strong>As On:</strong> {job.age?.asOn || "N/A"}
          </li>
          {job.age?.limits?.map((limit, i) => (
            <li key={i}>{limit}</li>
          ))}
          {job.age?.note && <li>{job.age.note}</li>}
        </ul>
      </div>
    </div>
  );
};

export default JobInfoTables;

